import { getToken } from "js/formatting/getToken";
import config from "config/config";
export async function UpdatePaymentProfile(policyDetails) {
  let options = {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify(policyDetails),
  };
  const response = await fetch(
    `${config.REG_API_BASE_URL}/Payment/updatepaymentprofile`,
    options
  );
  if (!response.ok) {
    throw response;
  } else {
    return;
  }
}
